import cloneDeep from 'lodash/cloneDeep';

import { toCamelCase } from '../objectKeysToCase';

export function massagePayAnyoneGetResponse(graphqlData) {
  const pay_anyone_config_response =
    graphqlData?.unauthenticated?.p2p?.pay_anyone_client_config;
  const payAnyoneConfigResponse = toCamelCase(pay_anyone_config_response);
  const dataConfig = cloneDeep(payAnyoneConfigResponse);

  const pay_anyone_response = graphqlData?.unauthenticated?.p2p?.pay_anyone;
  const payAnyoneResponse = toCamelCase(pay_anyone_response);
  const data = cloneDeep(payAnyoneResponse);

  if (data) {
    data.status = data?.payFriend?.uxStatus?.toLowerCase();
    data.flipperFlags = dataConfig;
    data.maintenanceMode = data?.flipperFlags?.maintenanceModeEnabled;

    const payFriendValuesToKeep = data?.payFriend;
    // Delete the old keys? keep for now for testing
    // delete data?.payAnyoneClientConfig;
    // delete data?.payFriend;
    const transformedData = {
      ...data,
      ...payFriendValuesToKeep,
    };
    return transformedData;
  }
}
